var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9578_18913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6998 1.09961L1.7998 10.9996M1.7998 10.9996L11.6998 20.8996M1.7998 10.9996L21.5998 10.9996",
    stroke: "white",
    strokeWidth: 2.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9578_18913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 0.199707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/ArrowWhite.9bed06322745b0c3cd858d707830922f.svg";
export { ForwardRef as ReactComponent };